;(function () {
    // Узнаём iPhone / iPod (iPad не попадает)
    const isiPhone = /iPhone|iPod/i.test(navigator.userAgent)

    if (!isiPhone) return

    // 1) Только для iPhone: запрещаем масштаб в viewport
    // const vp = document.querySelector('meta[name="viewport"]')
    // const extra = 'maximum-scale=1, user-scalable=no'
    // if (vp) {
    //     vp.setAttribute(
    //         'content',
    //         vp.content.includes('user-scalable')
    //             ? vp.content // если уже задано — не трогаем
    //             : vp.content
    //             ? vp.content + ', ' + extra
    //             : 'width=device-width, initial-scale=1, ' + extra
    //     )
    // } else {
    //     const m = document.createElement('meta')
    //     m.name = 'viewport'
    //     m.content = 'width=device-width, initial-scale=1, ' + extra
    //     document.head.appendChild(m)
    // }

    // 2) Только для iPhone: блокируем pinch
    // document.addEventListener(
    //     'touchmove',
    //     function (e) {
    //         if (e.scale !== undefined && e.scale !== 1) {
    //             e.preventDefault()
    //         }
    //     },
    //     { passive: false }
    // )

    // 3) Только для iPhone: блокируем зум по двойному тапу
    // let lastTouchEnd = 0
    // document.addEventListener(
    //     'touchend',
    //     function (e) {
    //         const now = Date.now()
    //         if (now - lastTouchEnd <= 300) {
    //             e.preventDefault()
    //         }
    //         lastTouchEnd = now
    //     },
    //     { passive: false }
    // )

    // 4) Чтобы не было авто-зумов на инпутах
    const style = document.createElement('style')
    style.textContent = `
    input, textarea, select { font-size: 16px; }
  `
    document.head.appendChild(style)
})()

;(function (m, e, t, r, i, k, a) {
    m[i] =
        m[i] ||
        function () {
            ;(m[i].a = m[i].a || []).push(arguments)
        }
    m[i].l = 1 * new Date()
    for (var j = 0; j < document.scripts.length; j++) {
        if (document.scripts[j].src === r) {
            return
        }
    }
    ;(k = e.createElement(t)),
        (a = e.getElementsByTagName(t)[0]),
        (k.async = 1),
        (k.src = r),
        a.parentNode.insertBefore(k, a)
})(
    window,
    document,
    'script',
    'https://mc.yandex.ru/metrika/tag.js?id=104357602',
    'ym'
)

try {
    ym(104357602, 'init', {
        ssr: true,
        webvisor: true,
        clickmap: true,
        ecommerce: 'dataLayer',
        accurateTrackBounce: true,
        trackLinks: true
    })
} catch {
    /* ym может отсутствовать при блокировке метрики — остальной бандл должен работать */
}

// Animation
gsap.registerPlugin(ScrollTrigger)

// Main: follow server markup — `.main__stat-slide` (desktop) vs `.main__mob` (mobile). Width >= 993
// missed viewports ≤992px where CSS still uses the desktop block (see main.scss max-width: 992px).
document.addEventListener('DOMContentLoaded', async () => {
    const main = document.querySelector('.main')
    if (!main) return

    const statSlides = Array.from(main.querySelectorAll('.main__stat-slide'))
    if (!statSlides.length) {
        sliderMain()
        return
    }

    const { default: Lenis } = await import('lenis')

    if (!window.__ozLenis) {
        const lenis = new Lenis({
            duration: 1,
            smoothWheel: true,
            wheelMultiplier: 1
        })
        lenis.on('scroll', ScrollTrigger.update)
        function syncLenisMetrics () {
            lenis.resize()
            ScrollTrigger.refresh()
        }
        window.addEventListener('load', syncLenisMetrics, { once: true })
        if (document.fonts?.ready) {
            document.fonts.ready.then(syncLenisMetrics)
        }
        function raf (time) {
            lenis.raf(time)
            requestAnimationFrame(raf)
        }
        requestAnimationFrame(raf)
        window.__ozLenis = lenis
    }

    const slidesData = statSlides.map(slide => ({
        image: slide.getAttribute('data-image'),
        imageAvif: slide.getAttribute('data-image-avif'),
        imageMobile: slide.getAttribute('data-image-mobile'),
        imageAvifMobile: slide.getAttribute('data-image-avif-mobile')
    }))
    const slidesCount = slidesData.length

    const mqMainStatMobile = window.matchMedia('(max-width: 767px)')

    function pickStatSlideAssets (data) {
        if (mqMainStatMobile.matches && data.imageMobile) {
            return {
                image: data.imageMobile,
                imageAvif: data.imageAvifMobile
            }
        }
        return { image: data.image, imageAvif: data.imageAvif }
    }

    function getBackgroundImageValue (data) {
        if (!data || !data.image) return 'none'
        if (data.imageAvif) {
            return `image-set(url(${data.imageAvif}) type("image/avif"), url(${data.image}) type("image/webp"))`
        }
        return `url(${data.image})`
    }

    function applyStatSlideBackgrounds () {
        statSlides.forEach((slide, idx) => {
            slide.style.backgroundImage = getBackgroundImageValue(pickStatSlideAssets(slidesData[idx]))
        })
    }

    applyStatSlideBackgrounds()
    mqMainStatMobile.addEventListener('change', applyStatSlideBackgrounds)

    function clamp (value, min, max) {
        return Math.min(Math.max(value, min), max)
    }

    const PARALLAX_RANGE = 15

    const header = document.querySelector('.header')

    function updateMainSlides () {
        const rect = main.getBoundingClientRect()
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight
        const totalScrollable = Math.max(main.offsetHeight - viewportHeight, 1)
        const traveled = clamp(-rect.top, 0, totalScrollable)
        const progress = clamp(traveled / totalScrollable, 0, 1)
        const virtual = progress * (slidesCount - 1)

        statSlides.forEach((slide, slideIdx) => {
            const y = slideIdx === 0
                ? 0
                : clamp((slideIdx - virtual) * 100, 0, 100)

            slide.style.transform = `translateY(${y}%)`

            const bgY = 50 + (y / 100) * PARALLAX_RANGE
            slide.style.backgroundPosition = `50% ${bgY}%`
        })

        if (header) {
            header.classList.toggle('header--hidden', progress >= 1)
        }
    }

    main.classList.add('main--scroll-slides')
    main.style.setProperty('--slides-count', String(slidesCount))
    updateMainSlides()

    window.addEventListener('scroll', updateMainSlides, { passive: true })
    window.addEventListener('resize', updateMainSlides)

    if (document.querySelector('.main__title-wrap, .main__btn-wrap, .main__item')) {
        const targets = gsap.utils.toArray(
            '.main__title-wrap, .main__btn-wrap, .main__item'
        )

        gsap.set(targets, {
            opacity: 0,
            y: 80,
            willChange: 'transform, opacity'
        })

        gsap.to(targets, {
            opacity: 1,
            y: 0,
            duration: 1.5,
            ease: 'power3.out',
            stagger: 0.06,
            overwrite: true
        })
    }
})

// Main-mob (markup exists only when server rendered mobile layout; desktop UA + narrow width has no `.main__mob`)
function sliderMain () {
    const swiperContainer = document.querySelector('.main__mob')
    const swiperEl = swiperContainer?.querySelector('.mySwiper')
    if (!swiperContainer || !swiperEl) return

    const nextSection = document.querySelector('.next-section')
    const swiper = new Swiper(swiperEl, {
        direction: 'vertical',
        slidesPerView: 1,
        spaceBetween: 30,
        effect: 'fade',
        mousewheel: false,
        touchStartPreventDefault: false,
        simulateTouch: true
    })

    let wheelTimeout = null

    swiperContainer.addEventListener(
        'wheel',
        e => {
            const activeSlide = swiper.slides[swiper.activeIndex]
            const rect = activeSlide.getBoundingClientRect()
            const viewportHeight = window.innerHeight

            const fullyVisible =
                Math.abs(rect.top) <= 2 &&
                Math.abs(rect.bottom - viewportHeight) <= 2

            if (!fullyVisible) {
                return
            }

            if (wheelTimeout) {
                e.preventDefault()
                return
            }

            const deltaY = e.deltaY

            if (deltaY > 0) {
                if (swiper.isEnd) {
                    if (nextSection) {
                        nextSection.scrollIntoView({ behavior: 'smooth' })
                        e.preventDefault()
                    }
                } else {
                    swiper.slideNext()
                    e.preventDefault()
                    wheelTimeout = setTimeout(() => {
                        wheelTimeout = null
                    }, 700)
                }
            } else if (deltaY < 0) {
                if (swiper.isBeginning) {
                } else {
                    swiper.slidePrev()
                    e.preventDefault()
                    wheelTimeout = setTimeout(() => {
                        wheelTimeout = null
                    }, 700)
                }
            }
        },
        { passive: false }
    )

    let startY = 0
    let isScrollingTouch = false

    swiperContainer.addEventListener(
        'touchstart',
        e => {
            startY = e.touches[0].clientY
            isScrollingTouch = false
        },
        { passive: true }
    )

    swiperContainer.addEventListener(
        'touchmove',
        e => {
            const currentY = e.touches[0].clientY
            const diffY = startY - currentY

            if (swiper.isEnd) {
                if (diffY > 0) {
                    swiper.allowTouchMove = false
                    isScrollingTouch = true
                } else {
                    swiper.allowTouchMove = true
                }
            } else {
                swiper.allowTouchMove = true
            }
        },
        { passive: true }
    )

    swiperContainer.addEventListener('touchend', () => {
        if (isScrollingTouch) {
            swiper.allowTouchMove = false
        } else {
            swiper.allowTouchMove = true
        }
    })

    swiper.on('slideChange', () => {
        swiper.allowTouchMove = true
    })
}

// Gallery: scroll expands full grid (see .gallery--active in main.scss)
const section = document.querySelector('.gallery')
if (section) {
    const bigImage = document.querySelector('.gallery__img--big img')
    const grid1 = document.querySelector('.images-grid--1')
    const grid2 = document.querySelector('.images-grid--2')
    const grid3 = document.querySelector('.images-grid--3')
    const grid4 = document.querySelector('.images-grid--4')
    if (bigImage && grid1 && grid2 && grid3 && grid4) {
        const gridAnim1 = gsap.to(grid1, {
            x: -30,
            ease: 'power1.inOut',
            paused: true
        })
        const gridAnim2 = gsap.to(grid2, {
            x: 30,
            ease: 'power1.inOut',
            paused: true
        })
        const gridAnim3 = gsap.to(grid3, {
            x: -30,
            ease: 'power1.inOut',
            paused: true
        })
        const gridAnim4 = gsap.to(grid4, {
            x: 30,
            ease: 'power1.inOut',
            paused: true
        })
        ScrollTrigger.create({
            trigger: bigImage,
            start: 'bottom bottom',
            end: 'bottom top',
            scrub: 0.5,
            onUpdate: self => {
                const progress = self.progress

                gsap.to([gridAnim1, gridAnim2, gridAnim3, gridAnim4], {
                    progress: progress,
                    duration: 0.3,
                    ease: 'power1.inOut'
                })

                if (progress > 0 && !section.classList.contains('gallery--active')) {
                    section.classList.add('gallery--active')
                } else if (
                    progress === 0 &&
                    section.classList.contains('gallery--active')
                ) {
                    section.classList.remove('gallery--active')
                }
            }
        })
    }
}

function initGalleryMobSlideshow() {
    const root = document.querySelector('.gallery__mob-slideshow')
    if (!root || root.dataset.galleryMobInit === '1') {
        return
    }

    if (typeof Swiper === 'undefined') {
        return
    }

    root.dataset.galleryMobInit = '1'

    new Swiper(root, {
        slidesPerView: 1,
        spaceBetween: 10,
        loop: true,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
    })
}

function scheduleGalleryMobSlideshow() {
    const run = () => initGalleryMobSlideshow()
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', run, { once: true })
    } else {
        requestAnimationFrame(run)
    }
}

scheduleGalleryMobSlideshow()

document.addEventListener('DOMContentLoaded', () => {
    const homeBg = document.querySelector('.home__bg-wrapper')
    if (!homeBg) {
        return
    }

    const sectionTargets = gsap.utils.toArray(homeBg.querySelectorAll('.section-top'))
    const textTargets = Array.from(homeBg.querySelectorAll('*')).filter(el =>
        [...el.classList].some(c => c.endsWith('__text')) && !el.classList.contains('house__text')
    )
    const detailsItemsTargets = gsap.utils.toArray(
        homeBg.querySelectorAll('.details__items')
    )
    const targets = gsap.utils.toArray(
        [...new Set([...sectionTargets, ...textTargets, ...detailsItemsTargets])]
    )

    targets.forEach(el => {
        gsap.set(el, {
            opacity: 0,
            y: 80,
            transformOrigin: 'center center',
            willChange: 'transform, opacity'
        })
    })

    const io = new IntersectionObserver(
        (entries, obs) => {
            entries.forEach(entry => {
                const el = entry.target
                if (entry.isIntersecting) {
                    if (!el._gsapTriggered) {
                        el._gsapTriggered = true
                        gsap.to(el, {
                            opacity: 1,
                            y: 0,
                            ease: 'power3.out',
                            duration: 1.5,
                            scrollTrigger: {
                                trigger: el,
                                start: 'top 80%',
                                end: 'top 40%'
                            }
                        })

                        obs.unobserve(el)
                    }
                }
            })
        },
        {
            threshold: 0.05
        }
    )

    targets.forEach(el => io.observe(el))

    const houseText = homeBg.querySelector('.house .house__text')
    const houseSectionTop = homeBg.querySelector('.house .section-top')

    if (houseText && houseSectionTop) {
        gsap.set(houseText, {
            opacity: 0,
            y: 80,
            transformOrigin: 'center center',
            willChange: 'transform, opacity'
        })
        gsap.to(houseText, {
            opacity: 1,
            y: 0,
            ease: 'power3.out',
            duration: 1.5,
            scrollTrigger: {
                trigger: houseSectionTop,
                start: 'top 80%',
                end: 'top 40%'
            }
        })
    }
})

// Area
;(function () {
    const video = document.getElementById('myVideo')
    let played = false
    let rafPending = false

    function checkAndPlay () {
        const video = document.querySelector('.my-video');
        if (!video) return;

        rafPending = false
        if (played) return
        const rect = video.getBoundingClientRect()
        // Условие: низ видео находится не ниже низа окна
        if (rect.bottom - 200 <= window.innerHeight) {
            const playPromise = video.play()
            if (playPromise !== undefined) {
                playPromise
                    .then(() => {
                        played = true
                        cleanup()
                    })
                    .catch(err => {
                        // Если автозапуск запрещён — отметим как сработавшее, чтобы не пытаться снова
                        console.warn('Автовоспроизведение не удалось:', err)
                        played = true
                        cleanup()
                    })
            } else {
                played = true
                cleanup()
            }
        }
    }

    function scheduleCheck () {
        if (rafPending || played) return
        rafPending = true
        requestAnimationFrame(checkAndPlay)
    }

    function cleanup () {
        window.removeEventListener('scroll', scheduleCheck)
        window.removeEventListener('resize', scheduleCheck)
    }

    // Первичная проверка (на случай, если элемент уже в нужной позиции)
    scheduleCheck()
    window.addEventListener('scroll', scheduleCheck, { passive: true })
    window.addEventListener('resize', scheduleCheck)
})()

;(function () {
    const section = document.getElementById('aboutMain')
    const video = document.getElementById('aboutVideo')
    if (!section || !video) return

    // playbackRate is not an HTML attribute; must be set in JS (some browsers reset it until metadata is ready).
    video.defaultPlaybackRate = 0.1
    video.playbackRate = 0.1
    video.addEventListener(
        'loadedmetadata',
        function syncPlaybackRate () {
            video.playbackRate = 0.1
        },
        { once: true }
    )

    function showVideo () {
        section.classList.add('about-main--video-ready')
        video.playbackRate = 0.5

        const playPromise = video.play()
        if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(function () {
                // Ignore autoplay rejection in strict browser policies.
            })
        }
    }

    if (video.readyState >= 2) {
        showVideo()
        return
    }

    video.addEventListener('loadeddata', showVideo, { once: true })
})()

document.addEventListener('DOMContentLoaded', () => {
    if (document.querySelector('.area__desc')) {
        const targets = gsap.utils.toArray('.area__desc')

        gsap.set(targets, { opacity: 0, y: 60, willChange: 'transform, opacity' })

        gsap.to(targets, {
            opacity: 1,
            y: 0,
            duration: 1.5,
            ease: 'power3.out',
            stagger: 0.06,
            overwrite: true,
            scrollTrigger: {
                trigger: '.area__desc',
                start: 'top 100%',
                end: 'top 40%'
            }
        })
    }
})

// Advantages
;(() => {
    const advantagesTimeline = gsap.timeline({ paused: true })

    function animateAdvantagesItems () {
        const itemsNodeList = document.querySelectorAll('.advantages__item')

        if (!itemsNodeList.length) return

        const items = Array.from(itemsNodeList)

        advantagesTimeline.clear()

        items.forEach(item => {
            const duration = parseFloat(item.dataset.duration)
            const safeDuration =
                Number.isFinite(duration) && duration > 0 ? duration : 0.6

            advantagesTimeline.to(
                item,
                {
                    opacity: 1,
                    y: 0,
                    duration: safeDuration,
                    ease: 'power2.out'
                },
                '+=0'
            )
        })

        advantagesTimeline.play()
    }

    const observerAdvantages = new IntersectionObserver(
        (entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    animateAdvantagesItems()
                    observer.disconnect()
                }
            })
        },
        {
            threshold: 0.5
        }
    )

    const advantagesSection = document.querySelector('.advantages__items')
    if (advantagesSection) {
        observerAdvantages.observe(advantagesSection)
    }
})()

document.addEventListener('DOMContentLoaded', () => {
    const targets = gsap.utils.toArray('.advantages .section-top')

    targets.forEach(el => {
        gsap.set(el, {
            opacity: 0,
            y: 80,
            transformOrigin: 'center center',
            willChange: 'transform, opacity'
        })
    })

    const io = new IntersectionObserver(
        (entries, obs) => {
            entries.forEach(entry => {
                const el = entry.target
                if (entry.isIntersecting) {
                    if (!el._gsapTriggered) {
                        el._gsapTriggered = true
                        gsap.to(el, {
                            opacity: 1,
                            y: 0,
                            ease: 'power3.out',
                            duration: 0.5,
                            scrollTrigger: {
                                trigger: el,
                                start: 'top 80%',
                                end: 'top 40%'
                            }
                        })

                        obs.unobserve(el)
                    }
                }
            })
        },
        {
            threshold: 0.05
        }
    )

    targets.forEach(el => io.observe(el))
})

// House
const house = document.querySelector('.house')
const houseSection = document.querySelector('.house__img')

const observerHouse = new IntersectionObserver(
    (entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                house.classList.add('house--active') // активируем 1 раз
                observer.unobserve(entry.target) // и больше не следим
            }
        })
    },
    { threshold: 0.5 }
)

if (houseSection) {
    observerHouse.observe(houseSection)
}

// ScrollTop
;(function () {
    try {
        if ('scrollRestoration' in history) {
            history.scrollRestoration = 'manual'
            console.log('scroll-reset: history.scrollRestoration = manual')
        }
    } catch (e) {
        console.warn('scroll-reset: cannot set history.scrollRestoration', e)
    }

    function forceScrollTop () {
        const docEl = document.documentElement
        const prev = docEl.style.scrollBehavior
        docEl.style.scrollBehavior = 'auto'
        window.scrollTo(0, 0)
        setTimeout(() => {
            docEl.style.scrollBehavior = prev || ''
        }, 0)
        console.log('scroll-reset: forced scrollTop')
    }

    window.addEventListener(
        'load',
        function () {
            setTimeout(forceScrollTop, 50)
        },
        { passive: true }
    )

    window.addEventListener(
        'pageshow',
        function (event) {
            console.log('scroll-reset: pageshow', event && event.persisted)
            if (event && event.persisted) {
                requestAnimationFrame(() =>
                    requestAnimationFrame(forceScrollTop)
                )
            } else {
                setTimeout(forceScrollTop, 0)
            }
        },
        { passive: true }
    )

    document.addEventListener(
        'DOMContentLoaded',
        function () {
            if (window.pageYOffset !== 0) {
                forceScrollTop()
            }
        },
        { passive: true }
    )
})()

document.addEventListener('DOMContentLoaded', function () {
    const forms = document.querySelectorAll('form.form')
    const csrfToken = document
        .querySelector('meta[name="csrf-token"]')
        ?.getAttribute('content')

    function feedbackFormId(form) {
        const explicitFormId = form.dataset.formId
        if (explicitFormId) return explicitFormId
        const modal = form.closest('.modal')
        if (!modal || !modal.id) return '1'
        const mid = modal.id
        if (mid === 'contactModal') return '1'
        if (mid === 'contactModal2') return 'contactModal2'
        const m = mid.match(/^contactModal--(.+)$/)
        return m ? m[1] : '1'
    }

    forms.forEach(form => {
        const submitBtn = form.querySelector('.form-btn')

        if (submitBtn && !submitBtn.querySelector('.btn-spinner')) {
            const spinner = document.createElement('span')
            spinner.className = 'btn-spinner'
            spinner.setAttribute('aria-hidden', 'true')
            submitBtn.appendChild(spinner)
        }

        form.addEventListener('submit', function (e) {
            e.preventDefault() // всегда отменяем стандартную отправку

            if (form.dataset.submitting === 'true') return

            // === ВАЛИДАЦИЯ ИМЕНИ И ТЕЛЕФОНА ===
            const nameInput = form.querySelector('input[name="name"]')
            const phoneInput = form.querySelector('input[name="phone"]')

            let hasError = false

            if (nameInput) {
                const nameGroup = nameInput.closest('.form-group')
                if (!nameInput.value.trim()) {
                    nameGroup && nameGroup.classList.add('form-group--active')
                    hasError = true
                } else {
                    nameGroup &&
                        nameGroup.classList.remove('form-group--active')
                }
            }

            if (phoneInput) {
                const phoneGroup = phoneInput.closest('.form-group')

                // убираем всё, кроме цифр
                const phoneDigits = phoneInput.value.replace(/\D/g, '')

                // телефон должен быть не пустым и содержать 11 цифр (+7 и ещё 10)
                if (!phoneInput.value.trim() || phoneDigits.length !== 11) {
                    phoneGroup && phoneGroup.classList.add('form-group--active')
                    hasError = true
                } else {
                    phoneGroup &&
                        phoneGroup.classList.remove('form-group--active')
                }
            }

            if (hasError) {
                const firstErrorInput = form.querySelector(
                    '.form-group.form-group--active input'
                )
                if (firstErrorInput) {
                    firstErrorInput.focus({ preventScroll: true })
                    firstErrorInput.scrollIntoView({
                        block: 'center',
                        behavior: 'smooth'
                    })
                }
                return
            }
            // === КОНЕЦ ВАЛИДАЦИИ ===

            const consentCheckboxes = form.querySelectorAll(
                '.form-check input[type="checkbox"]'
            )
            let consentInvalid = false
            consentCheckboxes.forEach(box => {
                const wrap = box.closest('.form-check')
                if (!box.checked) {
                    consentInvalid = true
                    wrap && wrap.classList.add('is-invalid')
                } else {
                    wrap && wrap.classList.remove('is-invalid')
                }
            })
            if (consentInvalid) {
                const firstUnchecked = form.querySelector(
                    '.form-check.is-invalid input[type="checkbox"]'
                )
                if (firstUnchecked) {
                    firstUnchecked.focus({ preventScroll: true })
                    firstUnchecked.closest('.form-check')?.scrollIntoView({
                        block: 'center',
                        behavior: 'smooth'
                    })
                }
                return
            }

            form.dataset.submitting = 'true'
            if (submitBtn) {
                submitBtn.classList.add('is-loading')
                submitBtn.setAttribute('disabled', 'disabled')
                submitBtn.setAttribute('aria-busy', 'true')
            }

            const formId = feedbackFormId(form)
            const data =
                $(form).serialize() +
                '&form_id=' +
                encodeURIComponent(formId) +
                (csrfToken ? '&_token=' + encodeURIComponent(csrfToken) : '')

            $.ajax({
                url: '/feedback',
                method: 'POST',
                data
            })
                .done(function () {
                    window.location.assign('/thankyou')
                })
                .fail(function () {
                    alert('Не удалось отправить форму. Попробуйте ещё раз.')
                })
                .always(function () {
                    form.dataset.submitting = 'false'
                    if (submitBtn) {
                        submitBtn.classList.remove('is-loading')
                        submitBtn.removeAttribute('disabled')
                        submitBtn.removeAttribute('aria-busy')
                    }
                })
        })

        form.addEventListener('change', e => {
            const t = e.target
            if (t.matches('.form-check input[type="checkbox"]')) {
                const wrap = t.closest('.form-check')
                wrap &&
                    wrap.classList.toggle('is-invalid', !t.checked)
            }
        })

        form.addEventListener('input', e => {
            const group = e.target.closest('.form-group')
            if (!group) return

            const target = e.target

            // Для телефона — проверяем именно количество цифр
            if (target.matches('input[name="phone"], input[type="tel"]')) {
                const digits = target.value.replace(/\D/g, '')

                if (digits.length === 11) {
                    group.classList.remove('form-group--active')
                } else {
                    group.classList.add('form-group--active')
                }
            } else {
                // Для остальных полей — как было
                if (target.value.trim().length > 0) {
                    group.classList.remove('form-group--active')
                } else {
                    group.classList.add('form-group--active')
                }
            }
        })
    })
})

document.addEventListener('DOMContentLoaded', function () {
    const swiper2 = document.querySelector('.mySwiper2');
    const monthPanel = document.querySelector('.months');

    if (!swiper2 || !monthPanel) return;

    const HEADER_HEIGHT = 0;   // если есть fixed-хедер
    const EXTRA_OFFSET = 50;    // твой верхний отступ
    const THRESHOLD = HEADER_HEIGHT + EXTRA_OFFSET;

    function onScroll() {
      const rect = swiper2.getBoundingClientRect();

      // как только верх слайдера доходит до (HEADER + 40px),
      // считаем, что он "достиг верха"
      if (rect.top <= THRESHOLD) {
        monthPanel.classList.add('month-panel--visible');
      } else {
        monthPanel.classList.remove('month-panel--visible');
      }
    }

    window.addEventListener('scroll', onScroll);
    onScroll();
});

document.addEventListener('DOMContentLoaded', () => {
    if (document.querySelector('.stages__title')) {
        const targets = gsap.utils.toArray(
            '.stages__title'
        );

        gsap.set(targets, { opacity: 0, y: 60, willChange: 'transform, opacity' });

        gsap.to(targets, {
            opacity: 1,
            y: 0,
            duration: 1.5,
            ease: 'power3.out',
            stagger: 0.06,
            overwrite: true
        });
    }
});

document.addEventListener('DOMContentLoaded', function () {
    const phoneInputs = document.querySelectorAll('input[type="tel"]')

    function mask (event) {
        let keyCode
        event.keyCode && (keyCode = event.keyCode)
        let pos = this.selectionStart
        if (pos < 3) event.preventDefault()
        let matrix = '+7 (___) ___-__-__',
            i = 0,
            def = matrix.replace(/\D/g, ''),
            val = this.value.replace(/\D/g, ''),
            new_value = matrix.replace(/[_\d]/g, function (a) {
                return i < val.length ? val.charAt(i++) || def.charAt(i) : a
            })
        i = new_value.indexOf('_')
        if (i !== -1) {
            i < 5 && (i = 3)
            new_value = new_value.slice(0, i)
        }
        let reg = matrix
            .substr(0, this.value.length)
            .replace(/_+/g, function (a) {
                return '\\d{1,' + a.length + '}'
            })
            .replace(/[+()]/g, '\\$&')
        reg = new RegExp('^' + reg + '$')
        if (
            !reg.test(this.value) ||
            this.value.length < 5 ||
            (keyCode > 47 && keyCode < 58)
        ) {
            this.value = new_value
        }
        if (event.type === 'blur' && this.value.length < 5) {
            this.value = ''
        }
    }

    phoneInputs.forEach(input => {
        input.addEventListener('input', mask, false)
        input.addEventListener('focus', mask, false)
        input.addEventListener('blur', mask, false)
        input.addEventListener('keydown', mask, false)
    })
})

;(function () {
    var COOKIE_NAME = 'ozarino_cookie_consent'
    var MAX_AGE_SEC = 365 * 24 * 60 * 60

    function getCookie (name) {
        var m = document.cookie.match(
            new RegExp(
                '(?:^|; )' +
                    name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') +
                    '=([^;]*)'
            )
        )
        return m ? decodeURIComponent(m[1]) : ''
    }

    function setConsentCookie () {
        document.cookie =
            COOKIE_NAME +
            '=1;path=/;max-age=' +
            MAX_AGE_SEC +
            ';SameSite=Lax'
    }

    function hasConsent () {
        if (getCookie(COOKIE_NAME) === '1') return true
        try {
            if (localStorage.getItem('cookieConsentDismissed') === 'true') {
                setConsentCookie()
                localStorage.removeItem('cookieConsentDismissed')
                return true
            }
        } catch (e) {}
        return false
    }

    function dismissCookies () {
        $('.cookies').hide()
        setConsentCookie()
    }

    $(function () {
        if (!hasConsent()) {
            $('.cookies').show()
        }
        $('#cookies-btn').on('click', dismissCookies)
        $('.cookies__close').on('click', dismissCookies)
    })
})()

;(function () {
    var COOKIE_NAME = 'ozarino_plan_instruction_dismissed'
    var MAX_AGE_SEC = 365 * 24 * 60 * 60

    function getCookie (name) {
        var m = document.cookie.match(
            new RegExp(
                '(?:^|; )' +
                    name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') +
                    '=([^;]*)'
            )
        )
        return m ? decodeURIComponent(m[1]) : ''
    }

    function setCookie (name, value) {
        document.cookie =
            name +
            '=' +
            encodeURIComponent(value) +
            ';path=/;max-age=' +
            MAX_AGE_SEC +
            ';SameSite=Lax'
    }

    document.addEventListener('DOMContentLoaded', function () {
        var instructionScreen = document.querySelector('.instruction-screen')
        var closeBtn = document.querySelector('.instruction-screen__item-close')

        if (!instructionScreen) return

        if (getCookie(COOKIE_NAME) !== '1') {
            instructionScreen.style.display = 'flex'
        }

        if (!closeBtn) return

        closeBtn.addEventListener('click', function () {
            instructionScreen.style.display = 'none'
            setCookie(COOKIE_NAME, '1')
        })
    })
})()

if (document.getElementById('myVideo')) {
    const video = document.getElementById('myVideo')
    const isMobile = window.matchMedia('(max-width: 767px)').matches
    const posterMobile = video.dataset.posterMobile
    const posterDesktop = video.dataset.posterDesktop
    const srcMobile = video.dataset.srcMobile
    const srcDesktop = video.dataset.srcDesktop

    video.poster = isMobile
        ? (posterMobile || posterDesktop || video.poster)
        : (posterDesktop || posterMobile || video.poster)
    video.src = isMobile ? (srcMobile || srcDesktop || '') : (srcDesktop || srcMobile || '')
}

function formatPrice (num) {
    return new Intl.NumberFormat('ru-RU').format(num)
}

window.openVideoModal = function openVideoModal (videoUrl) {
    console.log(videoUrl)
    const modal = document.getElementById('videoModal')
    modal.querySelector('video').src = videoUrl
}

// Lazy-load изображений и poster видео в модалках при первом открытии (классы modal--active / is-open)
document.addEventListener('DOMContentLoaded', () => {
    function loadModalLazyMedia (modal) {
        if (!modal) return
        modal.querySelectorAll('img[data-modal-src]').forEach(img => {
            const url = img.getAttribute('data-modal-src')
            if (!url || img.dataset.modalSrcLoaded) return
            img.src = url
            img.removeAttribute('data-modal-src')
            img.dataset.modalSrcLoaded = '1'
        })
        const video = modal.querySelector('video[data-modal-poster]')
        if (video && !video.dataset.modalPosterLoaded) {
            const posterUrl = video.getAttribute('data-modal-poster')
            if (posterUrl) {
                video.setAttribute('poster', posterUrl)
                video.removeAttribute('data-modal-poster')
                video.dataset.modalPosterLoaded = '1'
            }
        }
    }

    function isModalOpen (el) {
        return (
            el.classList.contains('modal--active') ||
            el.classList.contains('is-open')
        )
    }

    document.querySelectorAll('.modal').forEach(modal => {
        if (isModalOpen(modal)) {
            loadModalLazyMedia(modal)
        }
        const obs = new MutationObserver(() => {
            if (isModalOpen(modal)) {
                loadModalLazyMedia(modal)
            }
        })
        obs.observe(modal, { attributes: true, attributeFilter: ['class'] })
    })
})

document.addEventListener('DOMContentLoaded', () => {
    const PHOTO_GALLERY_AUTOPLAY = true

    const el = document.querySelector('.photo-gallery__swiper')
    if (!el || typeof window.Swiper === 'undefined') return

    const slides = el.querySelectorAll('.swiper-slide')
    if (!slides.length) return

    const multi = slides.length > 1

    const swiper = new window.Swiper(el, {
        slidesPerView: 'auto',
        spaceBetween: 20,
        speed: 500,
        grabCursor: true,
        watchSlidesProgress: multi,
        loop: multi,
        loopAdditionalSlides: 0,
        autoplay: multi && PHOTO_GALLERY_AUTOPLAY
            ? {
                  delay: 1000,
                  disableOnInteraction: false,
                  pauseOnMouseEnter: true
              }
            : false,
        breakpoints: {
            0: { spaceBetween: 12 },
            768: { spaceBetween: 20 }
        }
    })

    if (!multi || !PHOTO_GALLERY_AUTOPLAY || !swiper.autoplay) return

    const toggleAutoplayByVisibility = intersecting => {
        if (intersecting) {
            if (!swiper.autoplay.running) swiper.autoplay.start()
        } else if (swiper.autoplay.running) {
            swiper.autoplay.stop()
        }
    }

    const io = new IntersectionObserver(
        ([entry]) => {
            if (!entry) return
            toggleAutoplayByVisibility(entry.isIntersecting)
        },
        { root: null, threshold: 0.12, rootMargin: '0px' }
    )
    io.observe(el)

    requestAnimationFrame(() => {
        const rect = el.getBoundingClientRect()
        const vh = window.innerHeight || document.documentElement.clientHeight
        const inView = rect.bottom > 0 && rect.top < vh
        if (!inView) {
            swiper.autoplay.stop()
        }
    })
})

